import ThreeSixty from 'threesixty';

export default class Rotate360 {
  constructor(el) {
    this.$el = $(el);
    this.slider = null;
    this.interval = null;
    this.option = {
      interactive: true,
      currentImage: 0,
      reverse: false,
    };
    this.classes = {
      btnView: 'btn-tab-view',
      textLoading: '.text-loading',
    };
    this.dom = {
      $overlayDrag: this.$el.find('.mark-drag'),
      $threesixty: this.$el.find('.threesixty'),
      $groupLoading360: this.$el.find('.group-loading-360'),
      $loaderCenter: this.$el.find('.loader-center'),
    };
    this.$framers = this.dom.$threesixty.attr('data-frames');
    this.pathDesktop = this.dom.$threesixty.attr('data-path-desktop');
    this.pathMobile = this.dom.$threesixty.attr('data-path-mobile');
    this.loaded = false;
    this.preloadImage = false;
    this.intervalTime = 100;
    this.maxIntervalTime = 500;
    this.increment = 5;
    this.progress = 0;
    this.intervalNumber = null;
    this.flagInter = true;
  }

  init() {
    if (this.loaded) {
      return;
    }
    this.loaded = true;
    window.clearInterval(this.interval);
    this.addListeners();
    this.imageList();
  }

  isTablet() {
    return window.innerWidth >= 768;
  }

  getCurrentImage() {
    return this.slider.getCurrentFrame();
  }

  setCurrentImage(index) {
    const maxIndex = this.slider.frames - 1;
    if (index > maxIndex) {
      index = maxIndex;
    }

    const currentIndex = this.slider.getCurrentFrame();
    const diff = index - currentIndex;

    if (diff > 0) {
      for (let i = 0; i < diff; i++) {
        this.slider.next();
      }
    } else if (diff < 0) {
      for (let i = 0; i < Math.abs(diff); i++) {
        this.slider.previous();
      }
    } else {
      // currentIndex is already equal to index, do nothing
    }
  }

  updateProgress(imageLoaded, totalImage) {

    const percent = Math.floor((imageLoaded / totalImage) * 100);
    if (percent >= this.progress) {
      clearInterval(this.intervalNumber);
      this.dom.$loaderCenter.find(this.classes.textLoading).text(`${percent}%`);
    }
    if (this.flagInter === true) {
      this.flagInter = false;
      this.intervalNumber = setInterval(() => {
        this.progress++;
        this.dom.$loaderCenter.find(this.classes.textLoading).text(`${this.progress}%`);
      }, 1500);
    }
  }

  imageList() {
    const imgs = [];
    let imageLoaded = 0;
    for (let i = 1; i < this.$framers; i++) {
      if (this.isTablet()) {
        imgs.push(`${this.pathDesktop + i}.png`);
      } else {
        imgs.push(`${this.pathMobile + i}.png`);
      }
    }
    const totalImage = imgs.length;
    this.updateProgress(0, totalImage);
    imgs.forEach((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;

      img.onload = () => {
        imageLoaded++;
        if (imageLoaded >= totalImage) {
          this.slider = new ThreeSixty(this.dom.$threesixty[0], imgs, {
            interactive: true,
            currentImage: 0,
            reverse: false,
          });
          this.slider.init();
          this.dom.$loaderCenter.find(this.classes.textLoading).text('100%');
          this.dom.$loaderCenter.addClass('hidden');
          this.dom.$groupLoading360.removeClass('opacity-0');
        } else {
          this.updateProgress(imageLoaded, totalImage);
        }
      };
    });
    return imgs;
  }

  preloadFirstImage() {
    const img = new Image();
    const src = this.isTablet() ? `${this.pathDesktop}1.png` : `${this.pathMobile}1.png`;
    img.src = src;
    this.preloadImage = true;
  }

  addListeners() {
    this.$el.on('click mousedown touchstart', (e) => {
      if (!($(e.target).hasClass(this.classes.btnView) || $(e.target).parents(`.${this.classes.btnView}`).length)) {
        this.dom.$overlayDrag.addClass('opacity-0 swiper-mobile');
      }
    });
  }
}
